import { TemplateConfig } from '../../template-config.interface';

export const disneyCTV: TemplateConfig = {
  id: 'ctv',
  clientId: 'DISNEY',
  title: 'CTV',
  description: 'Template para contenido CTV',
  aspectRatio: 'horizontal',
  image: 'https://media.backend.doer.ar/brands/assets/DISNEY/templates/thumbnails/ctv.png',
  optimized_image: 'https://media.backend.doer.ar/brands/assets/DISNEY/templates/thumbnails/optimized/ctv.png',
  video: '',
  video_1920x1080: 'https://media.backend.doer.ar/brands/assets/DISNEY/templates/previews/ctv/ctv_1920x1080.mp4',
  video_1080x1350: 'https://media.backend.doer.ar/brands/assets/DISNEY/templates/previews/ctv/ctv_1080x1350.mp4',
  video_1080x1080: 'https://media.backend.doer.ar/brands/assets/DISNEY/templates/previews/ctv/ctv_1080x1080.mp4',
  video_300x250: 'https://media.backend.doer.ar/brands/assets/DISNEY/templates/previews/ctv/ctv_300x250.mp4',
  video_300x600: 'https://media.backend.doer.ar/brands/assets/DISNEY/templates/previews/ctv/ctv_300x600.mp4',

  formFields: [
    {
      key: 'title',
      label: 'Nombre del proyecto',
      type: 'input',
      placeholder: 'Nombre para identificar este asset',
      required: true
    },
    {
      key: 'description',
      label: 'Descripción',
      type: 'input',
      placeholder: 'Describí la serie o película',
      required: true,
      tooltipImage: 'https://media.doer.ar/Ejemplos/tooltips/ctv/description.png'
    },
    {
      key: 'video',
      label: 'Video',
      type: 'video',
      placeholder: 'https://cdn.filestackcontent.com/...',
      required: true,
      tooltipImage: 'https://media.doer.ar/Ejemplos/tooltips/ctv/video.png'
    },
    {
      key: 'background',
      label: 'Imagen de fondo',
      type: 'image',
      placeholder: 'https://ejemplo.com/fondo.jpg',
      required: true,
      tooltipImage: 'https://media.doer.ar/Ejemplos/tooltips/ctv/background.png'
    },
    {
      key: 'logo',
      label: 'Logo',
      type: 'image',
      placeholder: 'https://ejemplo.com/logo.png',
      required: true,
      tooltipImage: 'https://media.doer.ar/Ejemplos/tooltips/ctv/logo.png'
    }
  ],

  promptTemplate: `Haceme un video CTV de "El Oso", usando este video "https://media.backend.doer.ar/TESTDISNEY/examples/movies/12-the-bear.mp4"`
};
